module.exports = __webpack_public_path__ + "static/media/wallpaper-cel.98c41518.png";